import { render, staticRenderFns } from "./CarteiraVirtual.vue?vue&type=template&id=086a076e&"
import script from "./CarteiraVirtual.vue?vue&type=script&lang=js&"
export * from "./CarteiraVirtual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports